/* Handle the button that requests the export of the e-learning stats.
 * Show and hide popups that indicates the success or failure of the export request.
 */

import { fetch } from "../framework/api.js";
import * as Popup from "../framework/components/popup";
import * as Loading from "../framework/components/loading";
import * as UI from "../framework/ui";

// Delegated rather than bound to the button at load time: the dashboard is a `live_component`, so
// reaching the cockpit panel through its tab brings the button in with a LiveView patch, long after this
// module has run.
UI.onDataActionClick("elearning:request-export", async ({ el, event }) => {
  event.preventDefault();
  showLoader(el);

  let infoModalId = "popup-export-elearning-stats-success";
  try {
    const answer = await fetch(el.dataset.url, {
      method: "GET",
    });
    const data = await answer.json();
    if (data.success === false) {
      infoModalId = "popup-export-elearning-stats-error";
    }
  } catch (_error) {
    infoModalId = "popup-export-elearning-stats-error";
  }

  const exportModal = document.getElementById("popup-export-elearning-stats");
  Popup.close(exportModal);

  terminateLoader(el, "done");

  const closingModal = document.getElementById(infoModalId);
  await Popup.openAndWait(closingModal);
});

/**
 * Show the loading indicator in `parentElement` and hide the inner icon,
 * if any.
 *
 * The loader element is expected to have the class `js-loader`.
 * The icon element is expected to have the class `js-icon`.
 * @param {HTMLElement} parentElement Element containing the loader and
 * optional icon
 */
function showLoader(parentElement) {
  const loaderElement = parentElement.querySelector(".js-loader");

  if (loaderElement) {
    const iconElement = parentElement.querySelector(".js-icon");
    iconElement?.classList?.add?.("has-hidden");
    Loading.setState(loaderElement, "loading");
  }
}

/**
 * Terminates the loading indicator in `parentElement` and shows the
 * result icon, if any, for `durationInMs` milliseconds. If an icon is
 * present, it will be shown again after the loader is hidden.
 * @param {HTMLElement} parentElement Element containing the loader and optional
 * icon
 * @param {"done" | "error"} status Termination status of the loader.
 * @param {number} durationInMs Time during which the loader will be visible.
 */
function terminateLoader(parentElement, status, durationInMs = 500) {
  const iconElement = parentElement.querySelector(".js-icon");
  const loaderElement = parentElement.querySelector(".js-loader");

  if (loaderElement) {
    Loading.setState(loaderElement, status);
    setTimeout(() => {
      Loading.setState(loaderElement, "hidden");
      iconElement?.classList?.remove?.("has-hidden");
    }, durationInMs);
  }
}
